import { fetch } from 'owa-fetch';
// These are mostly informed by the Audiences specified for the meeting poll signed URLs in OWS'.
// localhost is present only for testing against OWS' running locally.  If you need to access localhost
// directly via http, you will need to add it here.
const trustedURLs = [
    'https://outlook\\.office\\.com/ows/',
    'https://outlook-tdf\\.office\\.com/ows/',
    'https://outlook-sdf\\.office\\.com/ows/',
    'https://localhost:\\d+/',
    'https://exchangelabs\\.live-int\\.com/ows/',
];

// These are the various paths we will trust from a signed URL perspective.
// TODO: remove CheckBookableAndUpdateTotalBookingsUsedByCode from trusted paths once bookwithme CheckBookable is working
const trustedPaths = ['CheckBookable', 'CheckBookableAndUpdateTotalBookingsUsedByCode'];

// This will take on the form of /^(trustedURL[0]|trustedURL[1]|...)/
const outlookURLPattern = new RegExp(
    `^(${trustedURLs.join('|')})[^?#]*(${trustedPaths.join('|')})`,
    'i'
);

function isValidUrl(url: string) {
    return outlookURLPattern.test(url);
}

export function validatedFetchForSignedUrl(
    url: string,
    request: RequestInit = {}
): Promise<Response> {
    if (isValidUrl(url)) {
        return fetch(url, {
            ...request,
            // Don't accept a redirect.
            redirect: 'error',
        });
    } else {
        return new Promise((_resolve, reject) => {
            reject(new Error('Untrusted URL'));
        });
    }
}
